// extracted by mini-css-extract-plugin
export var divider = "_3z-0";
export var dividerText = "_3z-1";